import { makeVar } from '@apollo/client';

const authUserVar = makeVar({});

export default authUserVar;
